<div class="thesis" [ngClass]="'thesis--' + type">
  <div class="thesis__container">
    <div class="thesis__bulb">
      <!-- Background images - all loaded, toggle visibility -->
      <img src="assets/images/Vector Profit.svg" [alt]="" class="thesis__bulb-bg" [class.thesis__bulb-bg--active]="type === 'profitable'" aria-hidden="true" />
      <img src="assets/images/Vector Loss.svg" [alt]="" class="thesis__bulb-bg" [class.thesis__bulb-bg--active]="type === 'loss'" aria-hidden="true" />
      <img src="assets/images/Vector Nodiff.svg" [alt]="" class="thesis__bulb-bg" [class.thesis__bulb-bg--active]="type === 'no-difference'" aria-hidden="true" />
      <img src="assets/images/Vector error.svg" [alt]="" class="thesis__bulb-bg" [class.thesis__bulb-bg--active]="type === 'error'" aria-hidden="true" />

      <!-- Bulb icons - all loaded, toggle visibility -->
      <img src="assets/images/Bulb-Convert.svg" [alt]="'profitable thesis indicator'" class="thesis__bulb-icon" [class.thesis__bulb-icon--active]="type === 'profitable'" />
      <img src="assets/images/Bulb-DontConvert.svg" [alt]="'loss thesis indicator'" class="thesis__bulb-icon" [class.thesis__bulb-icon--active]="type === 'loss'" />
      <img src="assets/images/Bulb-Indifferent.svg" [alt]="'no-difference thesis indicator'" class="thesis__bulb-icon" [class.thesis__bulb-icon--active]="type === 'no-difference'" />
      <img src="assets/images/Bulb-Error.svg" [alt]="'error thesis indicator'" class="thesis__bulb-icon" [class.thesis__bulb-icon--active]="type === 'error'" />
    </div>

    <div class="thesis__content">
      <!-- ERROR STATE -->
      <ng-container *ngIf="type === 'error'">
        <h3 class="thesis__error-banner">
          <ngx-axs-icon
            class="thesis__error-icon"
            axsType="alertSolid"
            [axsWidth]="24"
            [axsDecorative]="true"
            [style.--axs-icon-color]="'#FFAD00'"
          ></ngx-axs-icon>
          {{ content?.error_header }}
        </h3>
        <div class="thesis__text">
          <span>{{ errorDescription }}</span>
        </div>
      </ng-container>

      <!-- PROFITABLE STATE -->
      <ng-container *ngIf="type === 'profitable'">
        <div class="thesis__text">
          <span>{{ content?.intro_pay_approx }} </span>
          <span class="thesis__tax-amount thesis__clickable" (click)="onTaxAmountClick()">{{ rothConversionTaxAmount }} {{ content?.in_taxes }}</span>
          <span> {{ content?.today_period }} </span>
          <span class="thesis__bold">{{ content?.time_in }} {{ yearsUntilDist }} {{ yearsText }},</span>
          <span> {{ content?.profitable_could_have }} </span>
          <span class="thesis__bold">{{ assetDifference }} {{ content?.profitable_more_assets }}</span>
          <span> {{ content?.with_a }} </span>
          <span class="thesis__betr thesis__clickable" (click)="onBetrClick()">{{ content?.betr_label }}</span>
          <span class="thesis__bold"> {{ content?.of_word }} {{ betrValue }}</span>
          <span>{{ content?.which_may_make_conversion }} </span>
          <span class="thesis__bold">{{ desirabilityText }}</span>
          <span> {{ paymentPreposition }} </span>
          <span *ngIf="paymentArticle">{{ paymentArticle }} </span>
          <span class="thesis__bold">{{ paymentMethodText }}</span>
        </div>
      </ng-container>

      <!-- LOSS STATE -->
      <ng-container *ngIf="type === 'loss'">
        <div class="thesis__text">
          <span>{{ content?.intro_pay_approx }} </span>
          <span class="thesis__tax-amount thesis__clickable" (click)="onTaxAmountClick()">{{ rothConversionTaxAmount }} {{ content?.in_taxes }}</span>
          <span> {{ content?.today_period }} </span>
          <span class="thesis__bold">{{ content?.time_in }} {{ yearsUntilDist }} {{ yearsText }},</span>
          <span> {{ content?.loss_may_be }} </span>
          <span class="thesis__bold">{{ content?.loss_worse_off }} {{ assetDifference }}</span>
          <span> {{ content?.with_a }} </span>
          <span class="thesis__betr thesis__clickable" (click)="onBetrClick()">{{ content?.betr_label }}</span>
          <span class="thesis__bold"> {{ content?.of_word }} {{ betrValue }}</span>
          <span>{{ content?.which_may_make_conversion }} </span>
          <span class="thesis__bold">{{ desirabilityText }}</span>
          <span> {{ paymentPreposition }} </span>
          <span *ngIf="paymentArticle">{{ paymentArticle }} </span>
          <span class="thesis__bold">{{ paymentMethodText }}</span>
        </div>
      </ng-container>

      <!-- NO DIFFERENCE STATE -->
      <ng-container *ngIf="type === 'no-difference'">
        <div class="thesis__text">
          <span>{{ content?.no_diff_intro }} </span>
          <span class="thesis__bold">{{ content?.no_diff_text }}</span>
          <span> {{ content?.no_diff_future_account }} </span>
          <span class="thesis__tax-amount thesis__clickable" (click)="onTaxAmountClick()">{{ rothConversionTaxAmount }} {{ content?.in_taxes }}</span>
          <span> {{ content?.and_have }} </span>
          <span class="thesis__bold">{{ content?.no_diff_zero_assets }}</span>
          <span> {{ content?.no_diff_which_makes }} </span>
          <span class="thesis__bold">{{ desirabilityText }}{{ commonContent?.period }}</span>
        </div>
      </ng-container>
    </div>
  </div>
</div>
